import { SyncHasMany } from "@ember-data/model";
import DefaultBioExamModel from "core/models/default-bio-exam";
import Patient from "core/models/patient";
export default function bioExamResultsFilter(patient, bioExams) {
  if (!bioExams) return [];
  if (patient.isProIrc) {
    return bioExams.slice().filter(be => ["62238-1",
    // DFG CKD EPI
    "14682-9",
    // Créatinémie
    "2000-8",
    // Calcium
    "14879-1",
    // Phosphore
    "1751-7",
    // Albumine
    "1963-8",
    // Bicarbonate
    "2888-6",
    // Protéinurie sur 24h
    "34366-5",
    // Protéinurie / Créatinurie
    "32294-1",
    // Albuminurie
    "4548-4",
    // HBA1C
    "2823-3",
    // Pottassium,
    "718-7" // Hémoglobine
    ].includes(be.id));
  }
  return bioExams.slice();
}